import { modes } from "../modes";
import { permissions } from "../permissions/permissions";
import { roles } from "../roles";

export const notesPermissionProfiles = {
    EDIT_NOTES: {
        [modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.NOTES.EDIT_NOTES]
    },
    VIEW_NOTES: {
        [modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.NOTES.EDIT_NOTES, permissions.NOTES.VIEW_NOTES]
    },
    DELETE: {
        [modes.EDIT_PERMISSION]: [permissions.NOTES.DELETE]
    },
    VIEW_BY_CLIENT: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER, roles.SUPERVISOR]
    }
}